// extracted by mini-css-extract-plugin
module.exports = {"sectionC":"SectionC_sectionC__Z7Pop"};